// From: https://github.com/github/hotkey/blob/main/src/macos-uppercase-layer.ts.
/**
 * Map of "uppercase" symbols to the keys that would be pressed (while holding `Shift`) to type them on MacOS on an
 * English layout. Most of these are standardized across most language layouts, so this won"t work 100% in every
 * language but it should work most of the time.
 */
export const MACOS_UPPERCASE_LAYER_KEYS: Record<string, string> = {
    "`": "~",
    "1": "!",
    "2": "@",
    "3": "#",
    "4": "$",
    "5": "%",
    "6": "^",
    "7": "&",
    "8": "*",
    "9": "(",
    "0": ")",
    "-": "_",
    "=": "+",
    "[": "{",
    "": "}",
    "\\": "|",
    ";": ":",
    '"': '"',
    ",": "<",
    ".": ">",
    "/": "?",
    "q": "Q",
    "w": "W",
    "e": "E",
    "r": "R",
    "t": "T",
    "y": "Y",
    "u": "U",
    "i": "I",
    "o": "O",
    "p": "P",
    "a": "A",
    "s": "S",
    "d": "D",
    "f": "F",
    "g": "G",
    "h": "H",
    "j": "J",
    "k": "K",
    "l": "L",
    "z": "Z",
    "x": "X",
    "c": "C",
    "v": "V",
    "b": "B",
    "n": "N",
    "m": "M",
};
